// Hook lista ventas - Sprint 32.
import { useCallback, useEffect, useState } from 'react';
import * as svc from '../services/ventasService';

export default function useVentas() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(25);
  const [q, setQ] = useState('');
  const [estado, setEstado] = useState('');
  const [msg, setMsg] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await svc.listVentas({ page, per_page: perPage, q, estado });
      setItems(r.items); setTotal(r.total);
    } finally { setLoading(false); }
  }, [page, perPage, q, estado]);

  useEffect(() => { load(); }, [load]);

  return {
    items, total, loading, page, setPage, perPage,
    q, setQ, estado, setEstado, msg, setMsg, load,
  };
}
